import {
    Caption,
    Loader,
    pxToRem,
    useStyles,
    useTheme,
} from '@archipro-design/aria';

import type { CompanyImage } from '~/modules/professional/type';
import * as S from './CompanyImages.style';

import { Image } from '@rocco/components/image';
import React from 'react';

interface ImageSlideProps {
    slide: CompanyImage;
}

const ImageSlide = ({ slide }: ImageSlideProps) => {
    const { css } = useStyles();
    const { siteVariables } = useTheme();
    const [loading, setLoading] = React.useState(true);
    return (
        <div className={css(S.PhotoViewerSlide)}>
            <div
                className={css(S.PhotoViewerSlideContainer)}
                style={{
                    width: slide.isPortrait
                        ? pxToRem(slide.widthAfterCrop)
                        : pxToRem(1240),
                    height: pxToRem(840),
                }}
            >
                <Image
                    src={slide.src}
                    alt={slide.caption}
                    fill={true}
                    loading={'eager'}
                    fit={'cover'}
                    multiplied={false}
                    onLoad={() => setLoading(false)}
                />
                {loading && (
                    <Loader
                        size="larger"
                        variables={{
                            primarySVGFill: siteVariables.colors.white['000'],
                        }}
                        className={css(S.ImageLoadingSpinner)}
                    />
                )}
            </div>
            {slide.caption && (
                <Caption variant="04" className={css(S.PhotoViewerCaption)}>
                    {slide.caption}
                </Caption>
            )}
        </div>
    );
};

ImageSlide.displayName = 'ImageSlide';

export default ImageSlide;
